const NAMES: Record<number, string> = {
  5: 'Critical',
  4: 'High',
  3: 'Medium',
  2: 'Low',
  1: 'Info',
}

/**
 * Severity, as a colour *and* a word.
 *
 * Never colour alone: a colour-only severity scale excludes roughly one man in twelve
 * from doing the job, and the job is deciding which of these matters first.
 */
export function Severity({ id }: { id: number }) {
  return (
    <span className={`badge sev-${id}`} title={`Severity ${id} of 5`}>
      {NAMES[id] ?? 'Unknown'}
    </span>
  )
}
